var jellyBeansTargetAttributeName = 'data-form-jelly-beans-target';
var jellyBeansTargetAttribute = '[' + jellyBeansTargetAttributeName + ']';

function appendJellybean(targetParentElement, jellybeanId, jellybeanText, jellybeanGroupName) {
    var jellybeanElement = $('.dh-btn-jellybean.template').clone();
    $(jellybeanElement).removeClass('template');
    var jellybeanHtml = String.format(jellybeanElement[0].outerHTML, jellybeanId, jellybeanText, jellybeanGroupName);

    targetParentElement.append(jellybeanHtml);
}

function applyJellybeanGroup(jellybeanContainerElement, inputElements, jellybeanGroupName) {

    //clear
    clearJellybeanGroup(jellybeanContainerElement, jellybeanGroupName);

    //append jellybean per valued element
    $(inputElements).each(function (index) {
        //get the input value
        var inputValue = $(this).val();
        var inputId = $(this).attr('id');
        var inputIdSelector = String.format('#{0}', $(this).attr('id'));
        //if the value is blank or unchecked, skip
        if (!inputValue || !$(this).prop("checked")) {
            //
        }
        else {
            var inputName = $(this).attr('name');

            switch ($(this).attr('type')) {
                case 'checkbox':
                case 'radio':
                    var inputLabelElement = $(String.format('label[for={0}]', inputId));
                    inputValue = inputLabelElement.text();
                    break;
                default:
                //
            }
            var jellybeanText = inputValue;

            var friendlyGroupNameAttributeName = 'data-form-jelly-bean-friendly-group-name';

            if ($(this).attr(friendlyGroupNameAttributeName)) {
                jellybeanText = String.format("{0}: {1}", $(this).attr(friendlyGroupNameAttributeName), inputValue);
            }

            appendJellybean(jellybeanContainerElement, inputId, jellybeanText, inputName);
        }
    });
}

function clearJellybeanGroup(jellybeanContainerElement, jellybeanGroupName) {
    $(jellybeanContainerElement).children(String.format('[data-related-input-group={0}]', jellybeanGroupName)).remove();
}

function removeJellybean(jellybeanContainerElement, jellybeanId) {
    $(jellybeanContainerElement).children(String.format('[data-related-input={0}]', jellybeanId)).remove();
}

function closeJellybean(clickedElement) {
    var jellyBeanElement = $(clickedElement).closest('.dh-btn-jellybean');
    var targetInputId = $(jellyBeanElement).attr('data-related-input');
    var targetInputElement = $(String.format('#{0}', targetInputId));

    if (targetInputElement.length) {
        clearInputs(targetInputElement);
        jellyBeanElement.remove();
        $(targetInputElement).closest("form").submit();
    }
    else {
        var targetInputGroup = $(jellyBeanElement).attr('data-related-input-group');

        var modifiedQueryString = removeQueryStringParam(window.location.search, targetInputGroup);

        changeQueryString(modifiedQueryString);

        $(jellyBeanElement).closest("form").submit();
    }


}

$(document).on('click', '.dh-btn-jellybean[data-related-input] .jellybean-close', function (e) {
    closeJellybean($(this));
});

$('[data-form-jelly-beans-target][data-form-jelly-beans-group-action][data-form-jelly-beans-source][data-form-jelly-beans-group-name]').on('click', function () {
    var action = $(this).attr('data-form-jelly-beans-group-action');
    var groupName = $(this).attr('data-form-jelly-beans-group-name');
    var sourceElementId = String.format('{0}', $(this).attr('data-form-jelly-beans-source'));
    var sourceElement = $(sourceElementId);
    var targetElementSelector = $(this).attr(jellyBeansTargetAttributeName);
    var targetElement = $(targetElementSelector);

    if (
        sourceElement.length
        && groupName.length
        && targetElement.length
    ) {
        var inputs = $(sourceElement).find(':input');

        if (action == "apply") {
            applyJellybeanGroup(targetElement, inputs, groupName);
            $(this).closest("form").submit();
        }
        else if (action == "clear") {
            clearInputs(inputs);
            clearJellybeanGroup(targetElement, groupName);
            $(this).closest("form").submit();
        }
    }
});

$(':input[data-form-jelly-beans-target], [data-form-jelly-beans-target] :input').on('change', function () {

    var targetElementSelector = null;

    if ($(this)[0].hasAttribute(jellyBeansTargetAttributeName)) {
        targetElementSelector = $(this).attr(jellyBeansTargetAttributeName);
    }
    else if ($(this).closest(jellyBeansTargetAttribute).length) {
        targetElementSelector = $(this).closest(jellyBeansTargetAttribute).attr(jellyBeansTargetAttributeName);
    }

    if (targetElementSelector) {
        var targetElement = $(targetElementSelector);

        if (targetElement.length) {
            //get the input value
            var inputValue = $(this).val();
            var inputId = $(this).attr('id');
            var inputIdSelector = String.format('#{0}', $(this).attr('id'));
            //if the value is blank
            if (!inputValue || !$(this).prop("checked")) {
                //destroy the jelly bean
                removeJellybean(targetElement, inputId);
            }
            else {
                var inputName = $(this).attr('name');

                switch ($(this).attr('type')) {
                    case 'checkbox':
                    case 'radio':
                        var inputLabelElement = $(String.format('label[for={0}]', inputId));
                        inputValue = inputLabelElement.text();
                        break;
                    default:
                    //console.log("dawdad");
                }

                appendJellybean(targetElement, inputId, String.format("{0}: {1}", inputName, inputValue), inputName);
            }
        }
    }
});